import React from "react"
import PubSub from "pubsub-js"
import { PaymentElement } from "@stripe/react-stripe-js"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import usePaymentSubmission from "./use-payment-submission"
import PlatformAuth from "aldoo-ra/PlatformAuth"

const { useAuth } = PlatformAuth

const CheckoutForm = ({ store, isActive }) => {
  const texts = TextBundle({ id: "aldoo-store" })
  const { handleSubmit, ready, setReady, isReady, loading } = usePaymentSubmission(store)
  const [auth] = useAuth()

  const { getCartTotalValue, purchaseUserEmail, tempAuthForPurchase } = store

  const userEmail = auth?.email || tempAuthForPurchase?.email || purchaseUserEmail || ''

  const handlePaymentSubmit = async () => {
    await handleSubmit(store.invoiceData, userEmail)
  }

  React.useEffect(() => {
    if (!isActive) return

    PubSub.publish("PURCHASE_FLOW_UPDATE_BUTTON", {
      stepId: 'payment',
      onContinue: handlePaymentSubmit,
      onBack: () => PubSub.publish("PURCHASE_FLOW_BACK"),
      canContinue: isReady && !loading,
      loading: loading
    })
  }, [isReady, loading, isActive])

  return (
    <div className="h-full flex flex-col justify-between">
      <div className="pt-8 pb-[70px] px-2 md:px-6">
        <div className="mb-4">
          <PaymentElement
            onReady={() => setReady(true)}
            options={{
              defaultValues: {
                billingDetails: {
                  email: userEmail
                }
              }
            }}
          />
        </div>
      </div>

      <div className="sticky bottom-0 left-0 right-0 w-full h-[50px] flex items-center justify-end gap-2 px-6 bg-paper border-t-2 border-gray-200 z-[50]" style={{ boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
        <Typography variant="txt" className="text-text my-0">
          {texts?.total || "Estimated Total"}:
        </Typography>

        <Typography variant="body1_accent" className="text-text">
          {getCartTotalValue()}
        </Typography>
      </div>
    </div>
  )
}

export default CheckoutForm
